// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://gkcwvmogubgkgvmzwmlz.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdrY3d2bW9ndWJna2d2bXp3bWx6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0MzUxODIsImV4cCI6MjA3MzAxMTE4Mn0.cz6h2pYuFa4I_dwDE51ShAnkDdNUD2SS25k4XeshGjE";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
